import { NgModule } from '@angular/core';
import { BannerComponent } from './banner.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { BannerContentModule } from '../../directives/banner/banner-content.module';


@NgModule({
    declarations: [BannerComponent],
    imports: [
        MatIconModule,
        MatButtonModule,
        CommonModule,
        BannerContentModule
    ],
    exports: [
        BannerComponent
    ]
})
export class BannerModule {
}
